import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { createStore, applyMiddleware, compose } from "redux";
import { addLocaleData } from "react-intl";
import en from "react-intl/locale-data/en";
import fr from "react-intl/locale-data/fr";
//import { STRIPE_KEY } from "./helper/Config";

import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
// import $ from "jquery";
// import Popper from "popper.js";
import "bootstrap/dist/js/bootstrap.bundle.min";
import App from "./components/App";
import reducers from "./reducers";
import * as serviceWorker from "./serviceWorker";
import { SIGN_IN, SET_LOCALE } from "./actions";

addLocaleData([...en, ...fr]);

// Load merged.css late to ensure it overrides bundled styles and bypasses CRA parsing errors
const mergedStyleLink = document.createElement("link");
mergedStyleLink.rel = "stylesheet";
mergedStyleLink.href = "/assets/css/merged.css";
document.head.appendChild(mergedStyleLink);

const composeEnhanser = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhanser(applyMiddleware(thunk)));
//const store = createStore(reducers);
//console.log('here => '+STRIPE_KEY);
const token = localStorage.getItem("token");
const lang = localStorage.getItem("lang");
if (lang) {
  store.dispatch({ type: SET_LOCALE, payload: lang });
}

if (token) {
  store.dispatch({ type: SIGN_IN });
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
